import { tracked } from '@glimmer/tracking';
import BaseController from 'uplisting-frontend/pods/base/controller';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class SidebarEnquiryMessagesController extends BaseController {
  queryParams = [
    {
      replyId: 'reply',
    },
  ];

  @tracked replyId?: string;

  @tracked enquiry!: ModelRegistry['enquiry'];
  @tracked reply?: ModelRegistry['contextual-reply'];
  @tracked messagingChannels!: ModelRegistry['messaging-channel'][];
}
